/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PractitionerStrictHttpResponse } from '../../practitioner-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PractitionerProfileModel } from '../../models/practitioner-profile-model';

export interface ConsumerGetPractitionerFromRolePractitionerRoleIdGet$Params {
  practitionerRoleId: string;
}

export function consumerGetPractitionerFromRolePractitionerRoleIdGet(http: HttpClient, rootUrl: string, params: ConsumerGetPractitionerFromRolePractitionerRoleIdGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<PractitionerProfileModel>> {
  const rb = new RequestBuilder(rootUrl, consumerGetPractitionerFromRolePractitionerRoleIdGet.PATH, 'get');
  if (params) {
    rb.path('practitionerRoleId', params.practitionerRoleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PractitionerStrictHttpResponse<PractitionerProfileModel>;
    })
  );
}

consumerGetPractitionerFromRolePractitionerRoleIdGet.PATH = '/Consumer/GetPractitionerFromRole/{practitionerRoleId}';
